import { useCoords } from "./main7.mjs";
import { useCreateRoot } from "./main10.mjs";
import { useRender } from "./main11.mjs";
function useCanvas({
  longitude,
  latitude,
  altitude = 0,
  frameloop = "always",
  fromLngLat,
  ...renderProps
}) {
  const m4 = useCoords({
    latitude,
    longitude,
    altitude,
    fromLngLat
  });
  const { id, onAdd, onRemove, r3mRef } = useCreateRoot({ frameloop, fromLngLat, ...renderProps });
  const render = useRender(m4, r3mRef, frameloop);
  return { id, onAdd, onRemove, render };
}
export {
  useCanvas
};
//# sourceMappingURL=main8.mjs.map
